import { render, staticRenderFns } from "./UltimasChamadas.vue?vue&type=template&id=794f06fa"
import script from "./UltimasChamadas.vue?vue&type=script&lang=js"
export * from "./UltimasChamadas.vue?vue&type=script&lang=js"
import style0 from "./UltimasChamadas.vue?vue&type=style&index=0&id=794f06fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports